export default __webpack_public_path__ + "static/media/june_brundell.b0acb9c3.jpg";